class ChapterImages {
    constructor (element, options) {
        const defaults = {
            resizeTimeout: 150
        };

        this.settings = Object.assign({}, defaults, options);

        this.$chapterImages = element;
    }

    initialize () {
        const breakpoint = window.matchMedia('(min-width:1024px)');
        let imageSlider = null;
        let resizeTimer = null;

        const handleSlider = (Slider) => {
            if (breakpoint.matches === false || window.Modernizr.ie11) {
                if (imageSlider == null) {
                    imageSlider = new Slider(this.$chapterImages, {
                        speed: 500,
                        indicators: true,
                        prevnext: false,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        initAttr: 'data-chapterimages'
                    });
                }
            } else {
                if (imageSlider !== null) {
                    imageSlider.sliderDestroy();
                    imageSlider = null;
                }
            }
        };

        import('../../components/slider/slider').then(({ Slider }) => {
            const handleResize = () => {
                clearTimeout(resizeTimer);

                resizeTimer = window.setTimeout(() => {
                    handleSlider(Slider);
                }, this.settings.resizeTimeout);
            };

            handleSlider(Slider);
            window.addEventListener('resize', handleResize, false);
            window.addEventListener('orientationchange', handleResize, false);
        });
    }
}

export { ChapterImages };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$chapterImages = $context.querySelectorAll('[data-chapterimages="root"]');

        if ($$chapterImages.length > 0) {
            for (let i = 0; i < $$chapterImages.length; i++) {
                const $chapterImage = new ChapterImages($$chapterImages[i]);
                $chapterImage.initialize();
            }
        }
    }
});
